import { render } from "./DeleteUser.vue?vue&type=template&id=8188c8de&scoped=true"
import script from "./DeleteUser.vue?vue&type=script&lang=js"
export * from "./DeleteUser.vue?vue&type=script&lang=js"

import "./DeleteUser.vue?vue&type=style&index=0&id=8188c8de&scoped=true&lang=css"

import exportComponent from "C:\\_TimetipCode\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8188c8de"]])

export default __exports__